// @flow
import { get } from 'lodash';
import { reject } from 'redux-optimist-promise';

import { FETCH_ADDITIONAL_TRANSPORTS } from 'Store/booking/additional-transports/additionalTransports.action';

type State = ?HTTPError;

const initialState: State = null;

function additionalTransportsErrorReducer(state: State = initialState, action: ?Action<*>): State {
  switch (get(action, 'type')) {
    case FETCH_ADDITIONAL_TRANSPORTS:
      return initialState;

    case reject(FETCH_ADDITIONAL_TRANSPORTS):
      const error = get(action, 'payload.errors[0]', {});
      return {
        statusCode: error.statusCode || 500,
        message: error.message || 'UNKNOWN ERROR',
      };

    default:
      return state;
  }
}

export default additionalTransportsErrorReducer;
